import { request } from "../../../services/api"
import type { BaseApiResponse } from "../../../types/api.ts"
import type {
  BusinessDocumentsContractsParams,
  BusinessDocumentsContractsResponse,
  BusinessDocumentsProposalsParams,
  BusinessDocumentsProposalsResponse
} from "../types/business-documents.types.ts"

// These read the real Proposal/Contract business records
// (ProposalListSerializer / ContractListSerializer), not the generic file
// list narrowed by `document_type` — see GlobalFilesBusinessDocumentsTab's
// own docstring for that distinction, which this pair of endpoints exists
// to eventually replace it with.
const BASE_URL = "/project-management/global-files/business-documents"

const PATHS = {
  proposals: `${BASE_URL}/proposals/`,
  contracts: `${BASE_URL}/contracts/`
}

// GET /project-management/global-files/business-documents/proposals/ —
// bare `{results, status_summary}` shape, not the `details.data` envelope
// (matches `getProjectDocuments`/`getFolders`'s own bare-list convention).
export const getBusinessDocumentsProposals = async (
  params?: BusinessDocumentsProposalsParams
) => {
  return request.api.get<
    BusinessDocumentsProposalsResponse,
    BaseApiResponse<unknown>
  >(PATHS.proposals, params)
}

// GET /project-management/global-files/business-documents/contracts/
export const getBusinessDocumentsContracts = async (
  params?: BusinessDocumentsContractsParams
) => {
  return request.api.get<
    BusinessDocumentsContractsResponse,
    BaseApiResponse<unknown>
  >(PATHS.contracts, params)
}
